class AuditoriaTributariaContratoEstoqueService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    injector.invoke(['Confirm', 'Alert', (args...) => [@Confirm, @Alert] = args])

    configs.url = '/eficiencia-fiscal/auditoria-tributaria-contrato-estoque'

    super(configs, injector)

  processar: (contrato, event, action) ->
    @Confirm.success("Atenção!",
      "Este processo pode demorar até 24h para ser concluído. Ao término você receberá um aviso no e-mail informando que o arquivo CSV está disponível para download no Eficiência Fiscal.<br><br>
      <strong>IMPORTANTE</strong>: Os créditos necessários para a execução desta operação dependem da quantidade de itens do seu estoque. Essa operação será cobrada de seus créditos.", {
        'Exportar estoque': =>
          @save({contrato: contrato}, (data)=>
            if data.success
              @Alert.success("Processo de exportação iniciado com sucesso.", "Sucesso!")
              if (action)
                action()
            else
              @Alert.error("Ocorreu um erro ao iniciar processo de exportação.", "Atenção!", false)
          , event, 'Processando', true, null, true)
        'Cancelar': null
      })

angular.module('eficienciaFiscalModule').service('auditoriaTributariaContratoEstoqueService', AuditoriaTributariaContratoEstoqueService)
